var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(-180 39 39)",
    fill: "#6DA341"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0871 13.2509L25.7488 8.91273C25.4208 8.58497 24.8901 8.58473 24.5621 8.91216L10.9037 22.5429C10.7937 22.6526 10.7162 22.7908 10.6801 22.942L9.30865 28.6796C9.24091 28.9631 9.32547 29.262 9.53171 29.4683C9.69097 29.6276 9.90535 29.7144 10.1254 29.7144C10.1906 29.7144 10.2561 29.7065 10.3204 29.6911L16.0581 28.3197C16.2092 28.2836 16.3475 28.2064 16.4572 28.0961L30.0876 14.4377C30.4151 14.1097 30.4148 13.5784 30.0871 13.2509ZM15.4367 26.7417L11.26 27.7401L12.2581 23.5633L25.1549 10.6934L28.3067 13.8452L15.4367 26.7417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5296 12.1043L21.3423 13.2915L25.7081 17.6573L26.8954 16.47L22.5296 12.1043Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5237 14.2866L13.0287 24.7815L14.216 25.9687L24.7109 15.4738L23.5237 14.2866Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 22.5984L10.8753 23.7856L15.2134 28.1237L16.4006 26.9365L12.0625 22.5984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZz);
export default __webpack_public_path__ + "static/media/zz.0a6ff54b60379d4eb4a076f83b0c3abb.svg";
export { ForwardRef as ReactComponent };